import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Program", href: "#program" },
  { label: "Features", href: "#features" },
  { label: "Calculator", href: "#calculator" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <a href="#top" data-testid="navbar-logo" className="font-anton text-xl neon-text flicker tracking-wide">
          AIN'T DEAD YET
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-bebas tracking-[0.2em] text-sm text-[#A1A1AA] hover:text-[#39FF14] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#pricing" data-testid="navbar-cta" className="btn-brutal !py-2 !px-5 !text-sm">
            Get Program
          </a>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#39FF14]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#050505] border-t border-[#2A2A2A] px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-bebas tracking-[0.2em] text-lg text-[#A1A1AA] hover:text-[#39FF14]"
            >
              {l.label}
            </a>
          ))}
          <a href="#pricing" onClick={() => setOpen(false)} className="btn-brutal !py-2 text-center">
            Get Program
          </a>
        </div>
      )}
    </header>
  );
};
